export default __webpack_public_path__ + "static/media/Macaron-Cake.790c2713.jpg";